import { UntypedFormGroup } from '@angular/forms';
import { checkIfExpression } from '@jump-tech-frontend/angular-common';
import { IfDefinition, QuestionBase } from '@jump-tech-frontend/domain';

interface QuestionComponent {
  question: QuestionBase<any>;
  form: UntypedFormGroup;

  get isInvalid(): boolean;

  get show(): boolean;

  get value(): boolean;
}

export class BaseQuestionComponent implements QuestionComponent {
  question: QuestionBase<any>;
  form: UntypedFormGroup;

  get isInvalid() {
    return this.form.touched && this.form.invalid;
  }

  get show() {
    return (this.question.showIfPopulated !== true || this.form.value) && this.question.show !== false;
  }

  get value() {
    return this.form?.get(this.question.key)?.value || [];
  }

  set value(value: any) {
    this.form?.get(this.question.key)?.patchValue(value);
  }

  get showIf() {
    if (!this.question.showIf) {
      return true;
    }

    const currentForm = this.form.getRawValue();
    const parentForm = this.form.parent?.getRawValue() || {};
    const context = { ...parentForm, ...currentForm };

    const show = checkIfExpression(
      this.question.showIf as IfDefinition,
      context,
      this.form?.get(this.question.key)?.value
    );

    if (!show && this.form?.get(this.question.key)?.enabled) {
      this.form?.get(this.question.key)?.disable();
    } else if (show && this.form?.get(this.question.key)?.disabled) {
      this.form?.get(this.question.key)?.enable();
    }

    return show;
  }
}
